import { render, staticRenderFns } from "./render_select.vue?vue&type=template&id=156dfc0b&scoped=true&"
import script from "./render_select.vue?vue&type=script&lang=js&"
export * from "./render_select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156dfc0b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('156dfc0b')) {
      api.createRecord('156dfc0b', component.options)
    } else {
      api.reload('156dfc0b', component.options)
    }
    module.hot.accept("./render_select.vue?vue&type=template&id=156dfc0b&scoped=true&", function () {
      api.rerender('156dfc0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/form/render_fields/render_select.vue"
export default component.exports